import React from 'react';
import { Card, CardContent, Typography, Box, Avatar } from '@mui/material';
import CountUp from 'react-countup';

const TaskStatCard = ({ title, count, color = 'primary', icon }) => {
  return (
    <Card sx={{ 
      height: '100%',
      transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: 3
      }
    }}>
      <CardContent>
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          {icon && (
            <Avatar sx={{ bgcolor: `${color}.light`, color: `${color}.main` }}>
              {icon}
            </Avatar>
          )}
          <Typography variant="subtitle1" color="textSecondary">
            {title}
          </Typography>
        </Box>
        <Box display="flex" alignItems="baseline" gap={1}>
          <Typography variant="h4" component="div" color={color}>
            <CountUp end={count} duration={2} />
          </Typography>
          <Typography variant="body2" color="textSecondary">
            tasks
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TaskStatCard; 